export default "__VITE_PUBLIC_ASSET__cd314c66__"